// extracted by mini-css-extract-plugin
module.exports = {"cell-wrap":"Table_cell-wrap__3gi5W","truncate":"Table_truncate__1sotc","table":"Table_table__zktXG","row-title-span":"Table_row-title-span__3qMaK","cell":"Table_cell__2Lgj4"};